import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../components/UI/LandingPage/LandingPage";
import WebXRExperience from "../components/experience/WebXRExperience";
import OriginalExperiencePage from "../components/experience/OriginalExperiencePage";

const RouteHandler = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage autoplaySequence />} />
      <Route path="/main" element={<OriginalExperiencePage />} />
      <Route path="/legacy" element={<LandingPage autoplaySequence />} />
      <Route path="/legacy/main" element={<OriginalExperiencePage />} />
      <Route path="/prototype" element={<WebXRExperience />} />
    </Routes>
  );
};
export default RouteHandler;
